import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Лендинг витрин

export const eventChangeLocation = (): IInitialEvent => ({
  event: EVENT_TYPES.MAIN_EVENT,
  eventCategory: EVENT_CATEGORIES.CREDITS,
  eventAction: 'Изменение локации',
  eventLabel: 'Изменить город',
  eventValue: undefined,
});
